import React from 'react';

function Folder({ lineColor = 'white' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
    >
      <path
        d="M14.6673 11.6667C14.6673 12.0203 14.5268 12.3594 14.2768 12.6095C14.0267 12.8595 13.6876 13 13.334 13H2.66732C2.3137 13 1.97456 12.8595 1.72451 12.6095C1.47446 12.3594 1.33398 12.0203 1.33398 11.6667V2.33333C1.33398 1.97971 1.47446 1.64057 1.72451 1.39052C1.97456 1.14048 2.3137 1 2.66732 1H6.00065L7.33398 3H13.334C13.6876 3 14.0267 3.14048 14.2768 3.39052C14.5268 3.64057 14.6673 3.97971 14.6673 4.33333V11.6667Z"
        stroke={lineColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Folder;
